import styled from "styled-components";
import { useTranslation } from "react-i18next";
import questions from "../utils/questions";
import { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { FaMinus } from "react-icons/fa";
import { AdvancedMarker, APIProvider, Map } from "@vis.gl/react-google-maps";
import { useMediaQuery } from "react-responsive";

const Where = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 700px)' });
  const {t} = useTranslation();
  const [selected, setSelected] = useState(null);

  const position = {lat: 40.753866935931555, lng: 14.009317381104983};

  const toggle = (i) => {
    if (selected === i) {
      return setSelected(null);
    } 

    setSelected(i);
  }

  useEffect(() => {

  }, [selected])

  return (
    <Wrapper className="container">
        <div className="row">
          <div className="col-12 col-md-6 wrapper" style={isMobile ? {margin: '0px 0px 15px'} : {padding: '0px 15px'}}>
            <div className="col-12">
              <h1>{t('comeRaggiungerci')}</h1>
            </div>
            <div className="accordion">
              {
                questions.map((question, item) => {
                  return <div key={item} className="item">
                    <div className="title" onClick={() => toggle(item)}>
                      <h2>
                        {t(question.question)}
                      </h2>
                      <span>
                        {selected === item ? <FaMinus /> : <FaPlus />}
                      </span>
                    </div>
                    <div className={selected === item ? 'content show' : 'content'} dangerouslySetInnerHTML={{ __html: t(question.answer) }}>
                    </div>
                  </div>
                })
              }
            </div>
          </div>
          <div className="col-12 col-md-6 map" style={isMobile ? {margin: '15px 0px'} : {padding: '15px'}}>
              <APIProvider apiKey={'AIzaSyA7zTeRL20KTZpxmmgoSyDIBUZqgdxW1xk'}>
                <Map className='inside' defaultCenter={position} defaultZoom={14} mapId="b28b9e40a7377c78">
                  <AdvancedMarker position={position} />
                </Map>
              </APIProvider>
          </div>
        </div>
    </Wrapper>
  )
}

export default Where;

const Wrapper = styled.section`
  padding: 0px 0px 40px 0px;
  h1 {
    padding: 10px 10px 20px 10px;
    font-size: 22px;
  }
  .map {
    height: 400px;
    .inside {
      overflow: hidden;
      border-radius: 10px;
      height: 100%;
    }
  }
  .accordion {
    width: 100%;
  }
  .item {
    /* background: #f0ebe1; */
    background-color: var(--gray);
    border-radius: 10px;
    margin-bottom: 15px;
    padding: 10px 20px;
  }
  .title {
    h2 {
      padding-right: 15px;
      font-size: 20px;
    }
    color: var(--logo);
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 10px 0px;
  }
  .content {
    color: black;
    max-height: 0;
    line-height: 25px;
    overflow: hidden;
    transition: all 0.5s cubic-bezier(0, 1, 0, 1);
  }
  .content.show {
    line-height: 25px;
    height: auto;
    max-height: 9999px;
    transition: all 0.5s cubic-bezier(1, 0, 1, 0);
  }

`


